var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusic({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1 1V0.869516L18.974 0.903438L5.974 4.40344L5.9 4.42336V4.5V15.5724C5.39751 15.1481 4.73878 14.9 4 14.9C2.24477 14.9 0.9 16.2448 0.9 18C0.9 19.7552 2.24477 21.1 4 21.1C5.75523 21.1 7.1 19.7552 7.1 18V8.57638L17.9 5.63093V12.4724C17.3975 12.0481 16.7388 11.8 16 11.8C14.2448 11.8 12.9 13.1448 12.9 14.9C12.9 16.6552 14.2448 18 16 18C17.7552 18 19.1 16.6552 19.1 14.9V1ZM4 19.9C2.95523 19.9 2.1 19.0448 2.1 18C2.1 16.9552 2.95523 16.1 4 16.1C5.04477 16.1 5.9 16.9552 5.9 18C5.9 19.0448 5.04477 19.9 4 19.9ZM17.9 4.42362L7.1 7.36907V5.27638L17.9 2.33093V4.42362ZM16 16.9C14.9552 16.9 14.1 16.0448 14.1 15C14.1 13.9552 14.9552 13.1 16 13.1C17.0448 13.1 17.9 13.9552 17.9 15C17.9 16.0448 17.0448 16.9 16 16.9Z",
    fill: "#3936EF",
    stroke: "#3936EF",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.1c2944f35acc9d7b6dfefb796afde04f.svg";
export { ForwardRef as ReactComponent };